export default function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-white/80 dark:bg-gray-900/90 backdrop-blur-sm transition-all duration-500">
      <div className="flex flex-col items-center gap-6">
        {/* Hanger Logo Animation */}
        <div className="relative">
          <div className="w-24 h-24 relative animate-pulse">
            <img
              src="/logos/stylistgpt-icon-24.svg"
              alt="StylistGPT"
              className="w-full h-full"
            />
          </div>

          {/* Gradient overlay animation */}
          <div className="absolute inset-0 bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-indigo-500/20 animate-pulse rounded-full blur-md"></div>
        </div>

        {/* Text */}
        <div className="text-center">
          <h2 className="font-extralight text-xl tracking-[0.4em] uppercase text-gray-700 dark:text-gray-300 animate-pulse">
            STYLIST GPT
          </h2>
          <p className="font-light text-xs tracking-wider uppercase text-gray-500 dark:text-gray-400 mt-2">
            ATELIER
          </p>
        </div>

        {/* Loading indicator */}
        <div className="mt-4 relative">
          <div className="h-0.5 w-40 bg-gray-200 dark:bg-gray-700 overflow-hidden rounded-full">
            <div className="h-full bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 w-full animate-loadingBar"></div>
          </div>
        </div>
      </div>

      <span className="sr-only">Loading...</span>
    </div>
  );
}
